import { TypedValue } from '@client/new/helpers/types';

type Content<T extends string, V> = TypedValue<
  T,
  V & { id: string; isPublished: boolean }
>;

export type ContentLegacyGuide = Content<
  'ContentLegacyGuide',
  {
    title: string;
    contentId: number;
    count: number;
  }
>;

export type ContentLink = Content<
  'ContentLink',
  { title: string; url: string; coverImage: string }
>;

export type ContentTab = Content<'ContentTab', { name: string }>;

export type ContentType = ContentTab | ContentLink | ContentLegacyGuide;

export type ContentTypeName = ContentType['type'];

export type ContentMap = {
  [contentId: string]: ContentType;
};

export type ContentRootTree =
  | { id: string; items?: ContentTree[] }
  | { id: 'empty'; items?: ContentTree[] };

export type ContentTree = { id: string; items?: ContentTree[] };

export type ExtrasContent = {
  contentIds: ContentRootTree;
  contentMap: Record<string, ContentType>;
};

export type ValueByType<T extends ContentTypeName> = Extract<
  ContentType,
  { type: T }
>['value'];

export const emptyId = 'empty';
